export default "__VITE_ASSET__DaMNC8Nl__"